// export DsfInternalMail from './internalMail.vue'
export const DsfInternalMail= dsf.defineAsyncComponent("DsfInternalMail", () => import(/*webpackChunkName:"platform_homepage"*/ "./internalMail.vue"));